<template>
  <div class="all-picture-container">
    <div>
     <img class="back-btn" @click="goBack" src="../../../assets/images/activity/fragment/fragment-info/back.png">
     <div class="container">
      <div class="month" v-for="(item,index) in pieceMonthList" :key="index">
        <img class="bg-img" :src="getImgSrc(index)">
        <div class="piece" @click="gotoPage(index)">
          <img class="piece-item piece-one" v-for="(piece,pieceIndex) in item" :src="getPieceSrc(index,pieceIndex,piece.count)" :key="pieceIndex">
        </div>
        <div>图鉴收集进度</div>
        <div><span style="color:red">{{pieceNumList[index]}}</span> / 6</div>
      </div>

     <div class="bottom-text">本活动最终解释权归博世易加网所有</div>
    </div>
    </div>

  </div>
</template>

<script>
import activityApi from '@/api/activity'
export default {
  data () {
    return {
      pieceNumList: [0, 0, 0, 0, 0, 0],
      month: 0,
      pieceMonthList: [0, 0, 0, 0, 0, 0]
    }
  },
  created () {
    this.month = new Date().getMonth() + 1
    activityApi.collectPieceList().then(res => {
      if (res.data.resultCode === '0') {
        // 将获取的36个碎片信息分为每月6个
        let pieceList = res.data.resultData.collectPieceList
        for (var i = 0, j = 0; j < 6; i += 6, j++) {
          this.pieceMonthList[j] = pieceList.slice(i, i + 6)
        }
        console.log(this.pieceMonthList)
        this.pieceMonthList = Object.assign([], this.pieceMonthList)
        // 计算每月收集的个数
        this.pieceMonthList.forEach((month, index) => {
          for (let item of month) {
            if (item.count !== 0) {
              this.pieceNumList[index] = this.pieceNumList[index] + 1
            }
          }
        })
      }
    })
  },
  methods: {
    getImgSrc (index) {
      if (index + 7 === this.month) {
        let src = require(`../../../assets/images/activity/fragment/all-picture/${index + 7}-2.png`)
        return src
      } else {
        let src = require(`../../../assets/images/activity/fragment/all-picture/${index + 7}-1.png`)
        return src
      }
    },
    getPieceSrc (month, index, count) {
      if (count === 0) {
        let src = require('../../../assets/images/activity/fragment/all-picture/piece/blank.png')
        return src
      } else {
        let src = require(`../../../assets/images/activity/fragment/all-picture/piece/${month + 1}-${index + 1}.png`)
        return src
      }
    },
    gotoPage (index) {
      this.$router.push({
        name: 'activity-fragment-info',
        params: { index }
      })
    },
    goBack () {
      this.$router.back()
    }
  }

}
</script>

<style lang="less" scoped>
.all-picture-container {
  height: 812px;
  background-image: url("../../../assets/images/activity/fragment/all-picture/2021picture-bg.png");
  background-size: 100%;
}
.back-btn{
  position: relative;
  top: 10px;
  width: 90px;
}
.block {
  width: 100%;
  height: 80px;
}
.container {
  width: 90vw;
  height: 300px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.month {
  width: 42vw;
  height: 200px;
  margin-bottom: 10px;
  text-align: center;
  color: white;
  line-height: 20px;
  position: relative;
  .bg-img{
    width: 42vw;
  }
  .piece{
    width: 35vw;
    height: 35vw;
    position: absolute;
    top: 3.5vw;
    left: 3.5vw;
    display: flex;
    flex-wrap: wrap;
    .piece-item{
      width: calc(35vw / 3);
      height: calc(35vw / 2);
    }
  }
}

.picture {
  width: 80vw;
  height: 53.5vw;
  margin: 0 auto;
  background-color: antiquewhite;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.fragment-item {
  width: calc(80vw / 3);
  height: calc(53.5vw / 2);
  background-color: blue;
  overflow: hidden;
}
.none {
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.281);
}
.fragment-img {
  width: 100%;
  height: 100%;
}
.bottom-text{
    color:#00b6ff ;
    position: relative;
    font-size: 12px;
    bottom: -70px;
    left: -33.5px;
    transform: scale(0.73);
  }
</style>
